module.exports = __webpack_public_path__ + "img/工商管理.cfc14d7d.jpg";